export default {
    DEFAULT: 'LIGHT',
    LIGHT: require('./light'),
    DARK: require('./dark')
}